import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
    return (
        <div className="about-page">
            <div className="container">
                <section className="about-hero">
                    <h1>About SkillHive</h1>
                    <p className="hero-subtitle">
                        Connecting clients with trusted professionals for all home service needs
                    </p>
                </section>

                <section className="about-content">
                    <div className="content-block">
                        <h2>Our Mission</h2>
                        <p>
                            SkillHive is dedicated to making home services simple, safe, and accessible for everyone.
                            We bring together skilled professionals and clients on a single platform, ensuring
                            quality service delivery and customer satisfaction.
                        </p>
                    </div>

                    <div className="content-block">
                        <h2>Why Choose SkillHive?</h2>
                        <div className="features-grid">
                            <div className="feature-item">
                                <div className="feature-icon">✓</div>
                                <h3>Verified Professionals</h3>
                                <p>All professionals go through strict verification and background checks</p>
                            </div>
                            <div className="feature-item">
                                <div className="feature-icon">💰</div>
                                <h3>Transparent Pricing</h3>
                                <p>No hidden charges. Know the exact cost before booking</p>
                            </div>
                            <div className="feature-item">
                                <div className="feature-icon">⭐</div>
                                <h3>Rated & Reviewed</h3>
                                <p>Real ratings and reviews from verified customers</p>
                            </div>
                            <div className="feature-item">
                                <div className="feature-icon">🛡️</div>
                                <h3>Safe & Secure</h3>
                                <p>Your safety is our priority with insurance coverage</p>
                            </div>
                        </div>
                    </div>

                    <div className="content-block">
                        <h2>Our Story</h2>
                        <p>
                            Founded in 2024, SkillHive was born from a simple idea: make finding reliable home service
                            professionals as easy as booking a ride. We understand the challenges of finding trustworthy
                            professionals for home repairs and maintenance. That's why we created a platform that brings
                            together thousands of verified professionals across various service categories.
                        </p>
                        <p>
                            Today, we serve over 50,000 happy customers and work with 10,000+ skilled professionals
                            across multiple cities. Our platform ensures that every booking is smooth, every professional
                            is verified, and every customer is satisfied.
                        </p>
                    </div>

                    <div className="stats-section">
                        <div className="stat-box">
                            <h3>50K+</h3>
                            <p>Happy Customers</p>
                        </div>
                        <div className="stat-box">
                            <h3>10K+</h3>
                            <p>Verified Professionals</p>
                        </div>
                        <div className="stat-box">
                            <h3>100K+</h3>
                            <p>Services Completed</p>
                        </div>
                        <div className="stat-box">
                            <h3>4.8★</h3>
                            <p>Average Rating</p>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default AboutPage;
